import { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useLocation } from 'react-router-dom';

const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.initialize('UA-159231959-1');
        ReactGA.pageview(location.pathname + location.search);
    }, [location]);
};

export default usePageTracking;
